<div class="input-box">
	<div class="search-input">
		<input type="text" [ngStyle]="{ color: color }" [(ngModel)]="inputValue" (ngModelChange)="onInputChange($event)" class="search" [placeholder]="inputPlaceholder" />
		<icon *ngIf="icon" [type]="icon"></icon>
	</div>
</div>
